import { FC } from 'react';
import classnames from 'classnames';

import { useTab } from './useTab';
import { Font } from './sharedTypes';
import { Link } from '../../Link';

import styles from './tab.scss';

import type { Spacing } from './sharedTypes';

type TabProps = {
    name: string; // name must be unique among Tabs and correspond with TabPanel
    active: boolean;
    activeFont?: Font;
    inactiveFont?: Font;
    onActivate: () => void;
    contrast?: boolean;
    tabSpacing?: Spacing;
};

export const Tab: FC<TabProps> = ({
    name,
    onActivate,
    children,
    active,
    activeFont = 'mediumBodyHeavy',
    inactiveFont = 'mediumBody',
    contrast,
    tabSpacing = 'large',
}) => {
    const { tabId, panelId, tabCallbackRef, isActive, handleClick } = useTab(name);
    const font = active ? activeFont : inactiveFont;
    return (
        <li className={classnames(styles.listItemWrapper, styles[tabSpacing])} role="presentation">
            <Link
                dataTn={name}
                linkRef={tabCallbackRef}
                className={classnames(styles.tab, styles[font], {
                    [styles.active]: active,
                    [styles.contrast]: contrast,
                })}
                buyerLinkType="linkNoDecoration"
                role="tab"
                id={tabId || undefined}
                ariaControls={panelId}
                ariaSelected={isActive}
                tabIndex={isActive ? 0 : -1}
                onClick={() => {
                    handleClick();
                    onActivate();
                }}
            >
                {children}
            </Link>
        </li>
    );
};
